import { Box, Typography } from "@mui/material";
import Loading from "../Loading/Loading";
import { useTranslation } from "react-i18next";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";

export default function CardComponent({
  onClickCard,
  id,
  prices,
  name,
  selectedPlan,
  loadingPayments,
  badge
}: any) {
  const { t } = useTranslation();
  const isSelected = selectedPlan === id;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        background: semanticColors.surface.canvas,
        border: `1px solid ${semanticColors.border.middle}`,
        boxShadow: "0px 0px 16px rgba(30, 39, 79, 0.08)",
        borderRadius: "24px",
        overflow: "hidden",
        width: "100%",
        minWidth: "180px",
        maxWidth: "212px",
        position: "relative"
      }}
    >
      {/* Header */}
      <Box
        sx={{
          background: semanticColors.surface.container,
          width: "100%",
          height: "62px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: "6px",
          borderRadius: "24px 24px 0 0"
        }}
      >
        <Typography
          sx={{
            ...typography.heading.l,
            color: semanticColors.text.primary,
            textAlign: "center"
          }}
        >
          {name}
        </Typography>
      </Box>

      {/* Badge — absolutely positioned overlapping the header bottom */}
      <Box
        sx={{
          position: "absolute",
          top: "48px",
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: semanticColors.highlight.low,
          borderRadius: "40px",
          px: "8px",
          py: "2px",
          visibility: badge ? "visible" : "hidden"
        }}
      >
        <Typography
          sx={{
            ...typography.body.mBold,
            color: semanticColors.action.primary,
            textAlign: "center",
            whiteSpace: "nowrap"
          }}
        >
          {badge}
        </Typography>
      </Box>

      {/* Price */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: "8px",
          pt: "24px",
          pb: "16px",
          width: "100%"
        }}
      >
        <Typography
          sx={{
            ...typography.heading.xl,
            color: semanticColors.text.primary,
            textAlign: "center"
          }}
        >
          {new Intl.NumberFormat("pt-PT", {
            style: "currency",
            currency: "EUR"
          }).format(prices.price)}
        </Typography>
      </Box>

      {/* Logo + Button */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          px: "24px",
          pb: "24px",
          gap: "8px",
          width: "100%"
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "4px"
          }}
        >
          <img
            src="/CMD_symbol.png"
            style={{
              width: "32px",
              height: "32px",
              objectFit: "contain",
              filter: "grayscale(100%)"
            }}
          />
          <Typography
            sx={{
              ...typography.body.sSemibold,
              color: semanticColors.text.secondary,
              textAlign: "center"
            }}
          >
            CHAVE MÓVEL
          </Typography>
        </Box>

        <Box
          component="button"
          onClick={() => !loadingPayments && onClickCard(id)}
          disabled={loadingPayments}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: semanticColors.gradient.surface,
            borderRadius: "40px",
            height: "48px",
            minHeight: "48px",
            width: "100%",
            border: "none",
            cursor: loadingPayments ? "not-allowed" : "pointer",
            opacity: loadingPayments ? 0.7 : 1,
            px: "24px",
            gap: "8px"
          }}
        >
          {isSelected && loadingPayments ? (
            <Loading width={24} height={24} color="white" />
          ) : (
            <Typography
              sx={{
                ...typography.body.lBold,
                color: semanticColors.text.inverse,
                textAlign: "center"
              }}
            >
              {t("cmds.buy")}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
